export function _slug(str) {
  if (!str) return ''
  str = str.toString()
  str = str.toLowerCase()
  str = str.replace(/ /g, '');
  str = str.replace(/&/g, '-');
  str = str.replace(/--/, '-');
  str = str.replace(/-/g, '_'); // javascript variable names can not contain - 
  return str
}
/*
this was the php version:

private function _slug($str) {
		$str = strtolower($str);
		$str = str_replace([' ','&'], ['','-'], $str);
		$str = str_replace('--', '-', $str);
		return $str;
	}
*/

export function _break_word(str) {
  let s = str
  const replace_map = [
    {'Gebiedsontwikkeling': 'Gebieds-ontwikkeling'},
    {'Ondernemerssupport': 'Ondernemers-support'},
  ];

  replace_map.forEach((f) => {
    if(f.hasOwnProperty(str)) {
      s = f[str]
    }
  })
  return s
}



// WEBPACK FOOTER //
// ./scripts/vue/helpers.js